import React from "react";
import DropDownQuestion from "./DropDownQuestion";
// import FormData from "./QD.json";
function GenderQuestion(props) {
  const FormData = props.QDB;
  const QID = FormData.find((e) => e.QID === "Q1A");
  const getDefaultVal = () => {
    let defaultValue =
      props.defaultGender === undefined ? "Male" : props.defaultGender;
    return defaultValue;
  };
  // console.log(FormData);
  return (
    // <></>
    <DropDownQuestion
      handleValue={props.handleValue}
      Answer={getDefaultVal()}
      id={QID.Code_ID}
      QuestionText={QID.QuestionText}
      GuidelineText={QID.GuideText}
      Choices={QID.Choices.split("/")}
    />
  );
}

export default GenderQuestion;
